import { Injectable } from '@angular/core';
import * as i0 from "@angular/core";
export class TranslationService {
    constructor() {
        this.translations = {
            'presumptive': 'presuntivo',
            'definitive': 'definitivo',
        };
        this.regex = null; // Cache for the regex pattern
    }
    // Method to generate and cache the regex
    generateRegex() {
        const pattern = Object.keys(this.translations).join('|');
        return new RegExp(`\\b(${pattern})\\b`, 'gi');
    }
    // Method to translate a sentence
    translateSentence(sentence) {
        // Check if the sentence is null or undefined and return an empty string or the original sentence
        if (!sentence) {
            return ''; // Or return sentence if you'd prefer to return null or undefined.
        }
        if (!this.regex) {
            this.regex = this.generateRegex(); // Cache the regex once
        }
        // Perform the replacement only if sentence is a valid string
        return sentence.replace(this.regex, (match) => {
            const lowerMatch = match.toLowerCase();
            return this.translations[lowerMatch] || match;
        });
    }
    // Method to add new translations to the dictionary
    addTranslation(english, spanish) {
        this.translations[english.toLowerCase()] = spanish;
        this.regex = null; // Reset the cached regex when the dictionary is updated
    }
}
TranslationService.ɵfac = function TranslationService_Factory(t) { return new (t || TranslationService)(); };
TranslationService.ɵprov = i0.ɵɵdefineInjectable({ token: TranslationService, factory: TranslationService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(TranslationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], null, null); })();
//# sourceMappingURL=translation.service.js.map